import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOfferLine } from '../sale-offer-line';
import { SaleOfferLineProductBuilder } from './sale-offer-line-product-builder';
import { SaleOfferLineComplementBuilder } from './sale-offer-line-complement-builder';
import { SaleOfferLineOtherBuilder } from './sale-offer-line-other-builder';
import { parseNumber } from '../../utils/number.utils';

export class SaleOfferLineBuilder {

  static fromJson(json): SaleOfferLine {
    return (json) ? new SaleOfferLine(
      json.hash,
      parseNumber(json.type),
      parseNumber(json.position),
      SaleOfferLineProductBuilder.fromJson(json.saleOfferLineProduct),
      SaleOfferLineComplementBuilder.fromJson(json.saleOfferLineComplement),
      SaleOfferLineOtherBuilder.fromJson(json.saleOfferLineOther),
    ) : null;
  }

  static fromJsonList(list): SaleOfferLine[] {
    return (isArray(list)) ? sortByNumber('position', mapCollection(SaleOfferLineBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-line-builder.ts